<template>
    <v-btn
        color="primary"
        class="ma-2 white--text"
        elevation="2"
        @click="handleClick()"
    >
        <v-icon
            size="24"
            left
        >
            mdi-plus-box
        </v-icon>
        {{ title }}
    </v-btn>
</template>

<script>

export default {
    name: "AddButton",
    props: {
        title: {
            type: String,
            default: 'Add item'
        }
    },
    setup(props, ctx) {


        const handleClick = function(){
            ctx.emit('click')
        }

        return {
            handleClick,
        };
    }
};
</script>
